import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs/Observable';
import { ToasterModule, ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.css']
})

export class CreateAccountComponent implements OnInit {

  private toasterService: ToasterService;
  fullname = '';
  username = '';
  email = '';
  password = '';
  confirmPassword = '';

  eye = 'show';
  eyeSlash = 'hide';

  error_username = '';
  error_name = '';
  error_email = '';
  error_password = '';
  error_confirm_password = '';

  constructor(private apiService: ApiService, toasterService: ToasterService) {
    this.toasterService = toasterService;
  }

  ngOnInit() { }

  showPassword(pass: any): any {
      pass.type = 'text';
      this.eye = 'hide';
      this.eyeSlash = 'show';
    }

    hidePassword(pass: any): any {
      pass.type = 'password';
      this.eye = 'show';
      this.eyeSlash = 'hide';
    }

  signup() {
    if (this.fullname == '') {
      this.error_name = 'Name is required';
    } else {
      this.error_name = '';
    }

    if (this.username == '') {
      this.error_username = 'Username is required';
    } else {
      this.error_username = '';
    }

    if (this.email == '') {
      this.error_email = 'Email is required';
    } else {
      this.error_email = '';
    }

    if (this.password == '') {
      this.error_password = 'Password is required';
    } else {
      this.error_password = '';
    }

    if (this.password != this.confirmPassword) {
      this.error_confirm_password = 'Password not matching';
    } else {
      this.error_confirm_password = '';
      if (this.fullname != "" && this.username != "" && this.email != "" && this.password != "") {
        this.apiService.createAccount(this.fullname, this.username, this.email, this.password).subscribe((data:any) => {
          this.toasterService.pop('success', data.message);
          window.open("/login", "_self");
        },
        error => {
          if(error.statusText ==  "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
            window.open("/logout", "_self");
          }else  this.toasterService.pop('error', error.error.message);
        });
      }
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/components/create-account/create-account.component.ts